import React from 'react';
import { DollarSign, FileText, Shield, Clock, CheckCircle, Phone } from 'lucide-react';
import { firmInfoEs } from '../mockEs';
import DeftForm from '../components/DeftForm';

const consultationBenefitsEs = [
  { id: 1, title: '100% Gratis', description: 'Sin obligación, sin tarifas ocultas. Revisamos su caso sin costo alguno.', icon: 'DollarSign' },
  { id: 2, title: 'Evaluación de Caso', description: 'Obtenga asesoría legal experta sobre la fortaleza de su caso y compensación potencial.', icon: 'FileText' },
  { id: 3, title: 'Sin Costos Iniciales', description: 'Trabajamos con honorarios de contingencia: solo paga si ganamos su caso.', icon: 'Shield' },
  { id: 4, title: 'Respuesta Rápida', description: 'Respondemos rápidamente para proteger sus derechos y preservar evidencia crucial.', icon: 'Clock' }
];

const FreeConsultationEs = () => {
  return (
    <div style={{ marginTop: '70px' }}>
      {/* Hero Section */}
      <section style={{
        background: 'linear-gradient(135deg, var(--bg-card) 0%, var(--bg-page) 100%)',
        padding: '100px 0',
        textAlign: 'center',
        position: 'relative',
        overflow: 'hidden'
      }}>
        <div style={{
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          opacity: 0.05,
          backgroundImage: 'url(https://images.unsplash.com/photo-1758518731462-d091b0b4ed0d)',
          backgroundSize: 'cover',
          backgroundPosition: 'center'
        }} />
        <div className="container" style={{ position: 'relative', zIndex: 1 }}>
          <div style={{
            display: 'inline-block',
            padding: '8px 20px',
            background: 'var(--brand-primary)',
            color: 'var(--text-inverse)',
            borderRadius: '50px',
            fontSize: '0.9rem',
            fontWeight: '600',
            marginBottom: '24px',
            textTransform: 'uppercase',
            letterSpacing: '0.05em'
          }}>
            100% Gratis - Sin Obligación
          </div>
          <h1 className="heading-1" style={{ color: 'var(--brand-primary)', marginBottom: '24px' }}>
            Programe Su Consulta Gratuita
          </h1>
          <p className="body-large" style={{ color: 'var(--text-white)', maxWidth: '800px', margin: '0 auto 32px' }}>
            Obtenga asesoría legal experta sin costo. Revisaremos su caso, explicaremos sus derechos y delinearemos su camino hacia la compensación.
          </p>
          <div style={{ display: 'flex', gap: '16px', justifyContent: 'center', alignItems: 'center', flexWrap: 'wrap' }}>
            <a href={`tel:${firmInfoEs.phone}`} className="btn-primary" style={{ fontSize: '1.1rem', padding: '1.2em 2.5em' }}>
              <Phone size={20} style={{ marginRight: '8px' }} />
              Llamar {firmInfoEs.phone}
            </a>
          </div>
        </div>
      </section>

      {/* Benefits Section */}
      <section style={{ padding: '96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '64px', textAlign: 'center' }}>
            ¿Por Qué Programar una Consulta Gratuita?
          </h2>
          <div style={{
            display: 'grid',
            gridTemplateColumns: 'repeat(auto-fit, minmax(280px, 1fr))',
            gap: '32px'
          }}>
            {consultationBenefitsEs.map((benefit, index) => {
              const IconComponent = {
                'DollarSign': DollarSign,
                'FileText': FileText,
                'Shield': Shield,
                'Clock': Clock
              }[benefit.icon] || DollarSign;

              return (
                <div
                  key={benefit.id}
                  style={{
                    padding: '40px',
                    background: 'var(--bg-card)',
                    borderRadius: '16px',
                    border: '2px solid var(--border-light)',
                    textAlign: 'center',
                    animation: `fadeIn 0.6s ease-out ${index * 0.1}s backwards`
                  }}
                >
                  <div style={{
                    width: '70px',
                    height: '70px',
                    background: 'var(--brand-primary)',
                    borderRadius: '50%',
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    margin: '0 auto 24px'
                  }}>
                    <IconComponent size={32} color="var(--text-inverse)" />
                  </div>
                  <h3 className="heading-4" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>
                    {benefit.title}
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                    {benefit.description}
                  </p>
                </div>
              );
            })}
          </div>
        </div>
      </section>

      {/* Consultation Form Section */}
      <section style={{ padding: '96px 0', background: 'var(--bg-card)' }}>
        <div className="container">
          <div style={{ maxWidth: '800px', margin: '0 auto' }}>
            <div style={{ textAlign: 'center', marginBottom: '48px' }}>
              <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '16px' }}>
                Solicite Su Consulta Gratuita
              </h2>
              <p className="body-medium" style={{ color: 'var(--text-secondary)' }}>
                Complete el formulario y le contactaremos dentro de 2 horas para programar su consulta
              </p>
            </div>

            <div style={{
              background: 'var(--bg-page)',
              padding: '48px',
              borderRadius: '16px',
              border: '2px solid var(--border-light)'
            }}>
              {/* DeftForm Embed */}
              <DeftForm />

              <div style={{
                marginTop: '24px',
                padding: '20px',
                background: 'var(--bg-card)',
                borderRadius: '8px',
                border: '1px solid var(--brand-primary)'
              }}>
                <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
                  <CheckCircle size={24} color="var(--brand-primary)" />
                  <strong style={{ color: 'var(--brand-primary)' }}>Garantía Sin Riesgo</strong>
                </div>
                <p style={{ color: 'var(--text-secondary)', fontSize: '0.95rem', lineHeight: '1.6' }}>
                  Esta consulta es completamente gratuita y sin obligación. Trabajamos con honorarios de contingencia - no paga a menos que ganemos su caso. Su información es confidencial y está protegida por el privilegio abogado-cliente.
                </p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* What to Expect Section */}
      <section style={{ padding: '96px 0', background: 'var(--bg-page)' }}>
        <div className="container">
          <h2 className="heading-2" style={{ color: 'var(--brand-primary)', marginBottom: '64px', textAlign: 'center' }}>
            Qué Esperar Durante Su Consulta
          </h2>
          <div style={{
            maxWidth: '900px',
            margin: '0 auto',
            display: 'flex',
            flexDirection: 'column',
            gap: '32px'
          }}>
            {[
              {
                step: '1',
                title: 'Revisión del Caso',
                description: 'Escucharemos su historia y revisaremos los detalles de su lesión y cómo ocurrió.'
              },
              {
                step: '2',
                title: 'Análisis Legal',
                description: 'Explicaremos sus derechos legales, posibles reclamaciones y la fortaleza de su caso.'
              },
              {
                step: '3',
                title: 'Discusión de Estrategia',
                description: 'Delinearemos los pasos involucrados en perseguir su reclamación y qué esperar durante el proceso.'
              },
              {
                step: '4',
                title: 'Preguntas y Respuestas',
                description: 'Tendrá tiempo para hacer preguntas y obtener respuestas claras sobre su situación.'
              }
            ].map((item, index) => (
              <div
                key={index}
                style={{
                  display: 'flex',
                  gap: '24px',
                  alignItems: 'flex-start',
                  padding: '32px',
                  background: 'var(--bg-card)',
                  borderRadius: '12px',
                  border: '1px solid var(--border-light)',
                  animation: `fadeIn 0.6s ease-out ${index * 0.1}s backwards`
                }}
              >
                <div style={{
                  width: '50px',
                  height: '50px',
                  background: 'var(--brand-primary)',
                  borderRadius: '50%',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  fontSize: '1.5rem',
                  fontWeight: '900',
                  color: 'var(--text-inverse)'
                }}>
                  {item.step}
                </div>
                <div>
                  <h3 style={{ color: 'var(--brand-primary)', marginBottom: '8px', fontSize: '1.25rem', fontWeight: '600' }}>
                    {item.title}
                  </h3>
                  <p style={{ color: 'var(--text-secondary)', lineHeight: '1.6' }}>
                    {item.description}
                  </p>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default FreeConsultationEs;
